
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[store_name]",
      function () {
        return require("private-next-pages/[store_name]/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[store_name]"])
      });
    }
  